import { Mobile } from "@/models/Mobile";
import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";

const state = {
  rows: [],
  message: new httpError()
};

//getters

const getters = {
  getField
};

//Mutations
const mutations = {
  setMobile(state, mobiles) {
    state.rows = mobiles;
  },
  addRow(state, addressID) {
    if (state.rows.length > 0)
      state.rows.push(new Mobile({ orderType: "new", addressID: addressID }));
    else {
      state.rows = [new Mobile({ orderType: "new" })];
    }
  },
  deleteRow(state) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, index) {
    state.rows.splice(index, 1);
  },
  updateField
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit("setMobile", [new Mobile()]);
  },
  async getMobile({ commit, dispatch, rootState }) {
    try {
      var order = await HTTP.get(
        "order/GetMobile/" + rootState.orders.rows[0].orderID
      );
      if (order.data == null || order.data.length == 0) {
        order.data = [new Mobile({ orderType: "new" })];
      }
      commit("setMobile", order.data);
      dispatch(
        "setMessage",
        new httpError({ message: "Retreived OK", httpStatus: 200 })
      );
      return Promise.resolve(order);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({
          message: "Error getting order:" + err,
          httpStatus: 500
        })
      );
      return Promise.reject(err);
    }
  },
  async saveMobile({ commit, dispatch, rootState, state }) {
    try {
      var order = await HTTP.post(
        "order/AddMobile/" + rootState.orders.rows[0].orderID,
        state.rows
      );
      commit("setMobile", order.data);
      dispatch(
        "setMessage",
        new httpError({ message: "saved OK", httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        "setMessage",
        new httpError({ message: "unable to save:" + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      rows.push(state.rows[i - 1].mobileID);
      commit("deleteRow");
    }
    try {
      var mobiles = await HTTP.delete(
        "order/DeleteMobileFromOrder/" + rootState.orders.rows[0].orderID,
        { data: rows }
      );
      return Promise.resolve(mobiles);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  deleteRow({ rootState, state, commit, dispatch }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        "Order/DeleteMobileFromOrder/" + rootState.orders.rows[0].orderID,
        { data: [state.rows[index].mobileID] }
      )
        .then(() => {
          commit("removeRow", index);
          resolve(state.rows.length);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "unable to save:" + err.message,
              httpStatus: 500
            })
          );
          reject(err.message);
        });
    });
  },
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 2000);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
